import React from 'react';
import AddNewChild from './AddNewChild';
import AddAChildDevice from './../ConnectKidsDevice/AddAChildDevice';
import useLangTranslation from '../../../customHooks/languageProvider';
import { useSelector } from 'react-redux';

const AddNewChildWrapper = () => {
    const { newKidData } = useSelector(({ addNewChild }) => addNewChild);
    const { getLangTranslation } = useLangTranslation();

    if (!newKidData) {
        return (
            <AddNewChild
                getLangTranslation={getLangTranslation}
            />
        )
    }
    
    return <AddAChildDevice
        getLangTranslation={getLangTranslation}
    />
}

export default AddNewChildWrapper